import * as types from './mutation-types'

export default {
 
  [types.REGISTER_USER] (state, data) {
    // state.registeruser.push(data.registeruser)
    state.registeruser='registeruser'
  },
}
